import { render, staticRenderFns } from "./OpeningTimes.vue?vue&type=template&id=43a670ce&"
import script from "./OpeningTimes.vue?vue&type=script&lang=js&"
export * from "./OpeningTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports